import * as actions from '../actions/Identity';

const initialState = {
  identities: [],
  detail: {
    identityId: 2,
    shopId: 1,
    shopName: '店舗１',
    sealCertificate:
      'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/identity.jpg',
    businessLicense:
      'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/identity.jpg',
    registeredCopy:
      'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/identity.jpg',
    other:
      'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/identity.jpg',
    note: '何をアップロードしてよいかわからないので相談させてください',
    status: 'UNCONFIRMED',
    statusStr: '確認中',
    created_at: '2019-07-16 12:00:00'
  },
  identityTypes: [
    {
      id: 1,
      name: '運転免許証'
    },
    {
      id: 2,
      name: 'パスポート'
    },
    {
      id: 3,
      name: '在留カード'
    },
    {
      id: 4,
      name: '住基カード'
    }
  ],
  statuses: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'UNREGISTERED',
      name: '未登録'
    },
    {
      id: 'UNCONFIRMED',
      name: '確認中'
    },
    {
      id: 'RESERVED',
      name: '確認中（保留中）'
    },
    {
      id: 'REJECTION',
      name: '再提出依頼中'
    },
    {
      id: 'CONFIRMED',
      name: '確認済'
    },
    {
      id: 'NG',
      name: '審査NG'
    },
    {
      id: 'OTHER_THAN_CONFIRMED',
      name: '確認済以外'
    }
  ],
  error: false,
  status: 200,
  error_message: ''
};

const identities = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_IDENTITIES_SUCCESS:
      return Object.assign({}, state, action.payload);
    case actions.GET_IDENTITIES_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case actions.GET_GROUP_IDENTITIES_SUCCESS:
      return Object.assign({}, state, action.payload);
    case actions.GET_GROUP_IDENTITIES_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case actions.GET_IDENTITY_USER_KIDS_SUCCESS:
      return Object.assign({}, state, { identityUserKid: action.payload });
    case actions.GET_IDENTITY_USER_KIDS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error,
        identityUserKid: []
      });
    default:
      return state;
  }
};

export default identities;
